import React from 'react';
import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import * as ActionTypes from '../../../constants/ActionTypes';
import { merge, set as setPath } from 'lodash';
import { themeSystemDefault } from '../../../constants/SystemDefaults';

export const buttonsDataReducer = handleActions(
    {
        //Generic action that can potentially kill a lot of boiler plate code
        [ActionTypes.LEAF_PROPERTY_CHANGE]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target] };
            obj[action.layer][action.target][action.leaf] = action.value;
            obj['button'] = { ...state['button'] };
            obj['button'][action.layer][action.target] = { ...state[action.layer][action.target] };
            obj['button'][action.layer][action.target][action.leaf] = action.value;
            return update(state, { $merge: obj });
        },
        [ActionTypes.THEME_BUTTONS_SET_BUTTON_COLOR_NORMAL]: (state, action) => {
            let obj = {};
            obj[action.layer][action.target] = { ...state[action.layer][action.target], normal: action.normal };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_SPINNER1_COLOR]: (state, action) => {
            let obj = {
                button: {
                    ...state.button
                }
            };
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target], align: 'center' };
            obj['button'][action.layer]['spinner'] = {
                ...state['button'][action.layer]['spinner'],
                color1: action.color
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_SPINNER2_COLOR]: (state, action) => {
            let obj = {
                button: {
                    ...state.button
                }
            };
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target], align: 'center' };
            obj['button'][action.layer]['spinner'] = {
                ...state['button'][action.layer]['spinner'],
                color2: action.color
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_TEXT_TRANSFORM]: (state, action) => {
            let obj = {
                button: {
                    ...state.button
                }
            };
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target], align: 'center' };
            obj['button'][action.layer] = { ...state['button'][action.layer], textTransform: action.textTransform };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_BUTTON_COLOR_HOVER]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target], hover: action.hover };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_BUTTON_COLOR_DISABLED]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target], disabled: action.disabled };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_FONT_COLOR]: (state, action) => {
            let obj = {
                button: {
                    ...state.button
                }
            };
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target], align: 'center' };
            obj['button'][action.layer]['color'] = {
                ...state['button'][action.layer]['color'],
                [action.level]: action.color
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_BACKGROUND_COLOR]: (state, action) => {
            let obj = {
                button: {
                    ...state.button
                }
            };
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target], align: 'center' };
            obj['button'][action.layer]['background'] = {
                ...state['button'][action.layer]['background'],
                [action.level]: action.color
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_DISABLED_FONT_COLOR]: (state, action) => {
            let obj = {
                button: {
                    ...state.button
                }
            };
            obj['button'][action.layer] = { ...state['button'][action.layer], color: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_DISABLED_BACKGROUND_COLOR]: (state, action) => {
            let obj = {
                button: {
                    ...state.button
                }
            };
            // obj[action.layer] = {...state[action.layer]};
            // obj[action.layer][action.target] = {...state[action.layer][action.target]};
            // obj[action.layer][action.target][action.leaf] = action.value;
            obj['button'][action.layer] = { ...state['button'][action.layer], background: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_FONT]: (state, action) => {
            let obj = {
                button: {}
            };
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target], font: action.font };
            obj['button'] = { ...state['button'] };
            obj['button'][action.layer] = { ...state['button'][action.layer], font: action.font };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_FONT_STYLE]: (state, action) => {
            let obj = {
                button: {}
            };
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target], style: action.style };
            obj['button'] = { ...state['button'] };
            obj['button'][action.layer] = { ...state['button'][action.layer], style: action.style };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_FONT_SIZE]: (state, action) => {
            let obj = {
                button: {}
            };
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target], size: action.size };
            obj['button'] = { ...state['button'] };
            obj['button'][action.layer] = { ...state['button'][action.layer], fontSize: action.size };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_FONT_WEIGHT]: (state, action) => {
            let obj = {
                button: {}
            };
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target], weight: action.weight };
            obj['button'] = { ...state['button'] };
            obj['button'][action.layer] = { ...state['button'][action.layer], weight: action.weight };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINK_COLOR]: (state, action) => {
            let obj = {
                link: {}
            };
            let level = action.level;
            //   obj[action.layer] = {...state[action.layer]};
            //   obj[action.layer][action.target] = {...state[action.layer][action.target], weight: action.weight};
            obj['link'] = { ...state['link'] };
            //obj[action.layer][action.target] = {...state[action.layer][action.target], align: "center"};
            obj['link']['color'] = { ...state['link']['color'], [level]: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_FONT_COLOR]: (state, action) => {
            let obj = {
                button: {}
            };
            let level = action.level;
            //   obj[action.layer] = {...state[action.layer]};
            //   obj[action.layer][action.target] = {...state[action.layer][action.target], weight: action.weight};
            obj['button'] = { ...state['button'] };
            //obj[action.layer][action.target] = {...state[action.layer][action.target], align: "center"};
            obj['button']['link'] = { ...state['button']['link'] };
            obj['button']['link']['color'] = { ...state['button']['link']['color'], [level]: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_ICON_COLOR]: (state, action) => {
            let obj = {
                button: {}
            };
            let level = action.level;
            //   obj[action.layer] = {...state[action.layer]};
            //   obj[action.layer][action.target] = {...state[action.layer][action.target], weight: action.weight};
            obj['button'] = { ...state['button'] };
            //obj[action.layer][action.target] = {...state[action.layer][action.target], align: "center"};
            obj['button']['link'] = { ...state['button']['link'] };
            obj['button']['link']['icon']['color'] = {
                ...state['button']['link']['icon']['color'],
                [level]: action.color
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINK_TEXT_DECORATION]: (state, action) => {
            let obj = {
                link: {}
            };
            let level = action.level;
            //   obj[action.layer] = {...state[action.layer]};
            //   obj[action.layer][action.target] = {...state[action.layer][action.target], weight: action.weight};
            obj['link'] = { ...state['link'] };
            //obj[action.layer][action.target] = {...state[action.layer][action.target], align: "center"};
            obj['link']['textDecoration'] = { ...state['link']['textDecoration'], [level]: action.textDecoration };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_TEXT_DECORATION]: (state, action) => {
            let obj = {
                button: {}
            };
            let level = action.level;
            //   obj[action.layer] = {...state[action.layer]};
            //   obj[action.layer][action.target] = {...state[action.layer][action.target], weight: action.weight};
            obj['button'] = { ...state['button'] };
            //obj[action.layer][action.target] = {...state[action.layer][action.target], align: "center"};
            obj['button']['link'] = { ...state['button']['link'] };
            obj['button']['link']['textDecoration'] = {
                ...state['button']['link']['textDecoration'],
                [level]: action.textDecoration
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_FONT_SIZE]: (state, action) => {
            let obj = {
                button: {}
            };
            let level = action.level;
            //   obj[action.layer] = {...state[action.layer]};
            //   obj[action.layer][action.target] = {...state[action.layer][action.target], weight: action.weight};
            obj['button'] = { ...state['button'] };
            //obj[action.layer][action.target] = {...state[action.layer][action.target], align: "center"};
            obj['button']['link'] = { ...state['button']['link'], fontSize: action.size };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_ICON_SIZE]: (state, action) => {
            let obj = {
                button: {}
            };
            let level = action.level;
            //   obj[action.layer] = {...state[action.layer]};
            //   obj[action.layer][action.target] = {...state[action.layer][action.target], weight: action.weight};
            obj['button'] = { ...state['button'] };
            obj['button']['link'] = { ...state['button']['link'] };
            //obj[action.layer][action.target] = {...state[action.layer][action.target], align: "center"};
            obj['button']['link']['icon'] = { ...state['button']['link']['icon'], 'icon.size': action.size };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_TEXT_TRANSFORM]: (state, action) => {
            let obj = {
                button: {}
            };
            let level = action.level;
            //   obj[action.layer] = {...state[action.layer]};
            //   obj[action.layer][action.target] = {...state[action.layer][action.target], weight: action.weight};
            obj['button'] = { ...state['button'] };
            //obj[action.layer][action.target] = {...state[action.layer][action.target], align: "center"};
            obj['button']['link'] = { ...state['button']['link'], textTransform: action.textTransform };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_FONT_WEIGHT]: (state, action) => {
            let obj = {
                button: {}
            };
            let level = action.level;
            //   obj[action.layer] = {...state[action.layer]};
            //   obj[action.layer][action.target] = {...state[action.layer][action.target], weight: action.weight};
            obj['button'] = { ...state['button'] };
            //obj[action.layer][action.target] = {...state[action.layer][action.target], align: "center"};
            obj['button']['link'] = { ...state['button']['link'], weight: action.weight };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_LINKICON_FONT_STYLE]: (state, action) => {
            let obj = {
                button: {}
            };
            let level = action.level;
            //   obj[action.layer] = {...state[action.layer]};
            //   obj[action.layer][action.target] = {...state[action.layer][action.target], weight: action.weight};
            obj['button'] = { ...state['button'] };
            //obj[action.layer][action.target] = {...state[action.layer][action.target], align: "center"};
            obj['button']['link'] = { ...state['button']['link'], style: action.style };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_TEXT_ALIGN]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = { ...state[action.layer][action.target], align: action.align };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_BUTTON_STYLE]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = {
                ...state[action.layer][action.target],
                buttonStyle: action.buttonStyle
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_BUTTON_SHAPE]: (state, action) => {
            let obj = {};
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = {
                ...state[action.layer][action.target],
                buttonShape: action.buttonShape
            };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_BORDER_STYLE]: (state, action) => {
            let obj = {
                button: {}
            };
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = {
                ...state[action.layer][action.target],
                borderStyle: action.borderStyle
            };
            obj['button'] = { ...state['button'] };
            obj['button'][action.layer] = { ...state['button'][action.layer], borderStyle: action.borderStyle };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_BUTTONS_SET_BORDER_WIDTH]: (state, action) => {
            let obj = {
                button: {}
            };
            obj[action.layer] = { ...state[action.layer] };
            obj[action.layer][action.target] = {
                ...state[action.layer][action.target],
                borderWidth: action.borderWidth
            };
            obj['button'] = { ...state['button'] };
            obj['button'][action.layer] = { ...state['button'][action.layer], borderWidth: action.borderWidth };
            return { ...state, ...obj };
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (action.theme.hasOwnProperty('button')) {
                return { ...state, button: action.theme.button };
            }

            return state;
        },
        //TODO: temporary partial implementation of global reducer
        [ActionTypes.THEME_MODIFY_KEY]: (state, action) => {
            let pathCheck = action.path.split('.');
            if (pathCheck[0] === 'buttons') {
                pathCheck.shift();
                return merge({}, state, setPath({}, pathCheck, action.value));
            }

            return state;
        }
    },
    themeSystemDefault.button
);

export default buttonsDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/buttons.js